import { ToggleGroup, ToggleGroupItem } from '../ui/toggle-group';
import { Badge } from '../ui/badge';

export function TaxonomyChipRow({ categories, value, onChange, counts }) {
  const total = Object.values(counts || {}).reduce((sum, n) => sum + n, 0);

  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(v) => v && onChange(v)}
      className="flex-wrap justify-start gap-1.5"
    >
      <ToggleGroupItem value="all" size="sm" className="gap-1.5 text-xs">
        All
        <Badge variant="outline" className="text-[10px]">{total}</Badge>
      </ToggleGroupItem>
      {categories.map(({ key, label }) => (
        <ToggleGroupItem key={key} value={key} size="sm" className="gap-1.5 text-xs">
          {label}
          <Badge variant="outline" className="text-[10px]">{counts?.[key] || 0}</Badge>
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
